import React, { createContext, useState, useEffect } from 'react';
import { getApiUrl } from '../utils/apiConfig';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState({});
  
  const fetchConfig = async () => {
    const res = await fetch(getApiUrl('/api/configuracion'));
    const data = await res.json();
    const configObj = {};
    data.forEach(item => {
      configObj[item.clave] = item.valor;
    });
    setConfig(configObj);
  };
  
  // Actualizar título y favicon cuando cambia la configuración
  useEffect(() => {
    if (config.organizationName) {
      document.title = `${config.organizationName} - Sistema de Gestión`;
    }
    
    if (config.logo) {
      // Actualizar el favicon con el logo de la organización
      const favicon = document.getElementById('favicon');
      if (favicon) {
        favicon.href = config.logo;
      } else {
        // Si no existe el elemento, crearlo
        const link = document.createElement('link');
        link.id = 'favicon';
        link.rel = 'icon';
        link.type = 'image/x-icon';
        link.href = config.logo;
        document.head.appendChild(link);
      }
    }
  }, [config]);
  
  useEffect(() => {
    fetchConfig();
  }, []);
  
  const updateConfig = async (clave, valor) => {
    await fetch(getApiUrl('/api/configuracion'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ clave, valor })
    });
    fetchConfig();
  };
  
  return (
    <ConfigContext.Provider value={{ config, updateConfig, fetchConfig }}>
      {children}
    </ConfigContext.Provider>
  );
};
